export default __webpack_public_path__ + "images/0354ce0047ea697ef4b209e61ffc1796-accessories.webp";